<div class="case-flow-timeline-container">
  <!-- <p class="page-heading d-flex justify-content-center">Timeline</p> -->
  <!-- <hr /> -->
  <div class="container-body pb-3">
    <div class="timeline-wrapper">
      <div class="timeline-line"></div>

      <div class="timeline-content">
        <div
          class="timeline-item"
          *ngFor="let item of timelineData; let i = index"
          [ngClass]="{
            'timeline-right': isSingleItem() || i % 2 === 0,
            'timeline-left': !isSingleItem() && i % 2 !== 0
          }">
          <div class="timeline-dot"></div>
          <div class="timeline-details">
            <div class="d-flex justify-content-start">
              <span class="">Background Status</span><span>:</span><span> {{ item.status }}</span>
            </div>
            <div class="d-flex justify-content-start">
              <span class="">Date & Timestamp</span><span>:</span><span> {{ item.date }}</span>
            </div>
            <div class="d-flex justify-content-start">
              <span class="">Name</span><span>:</span><span> {{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <hr/>
  <div class="mb-5" *ngIf="!hidePreviousNextButtons">
    <button class="btn btn-outline-secondary float-left " (click)="moveToPrevious()">
      <span class="fas fa-arrow-left"></span> Previous
    </button>
    <!-- <button class="btn btn-primary float-right" (click)="moveToNext()">Submit</button> -->
  </div>
</div>
